import { ProviderToken } from '@angular/core';
import { Method } from 'eurogard-pattern';
import { ControlOptions } from '@rxap/utilities';
import { UseMethod, UseMethodConfig } from './extract-methods.mixin';
import { RxapFormControl } from 'eurogard-forms';
import { ExtractControlMixin, ExtractFormDefinitionMixin } from 'eurogard-form-system';
import { Mixin } from 'eurogard-mixin';
import { ExtractMethodMixin } from './extract-method.mixin';

export const OPTIONS_METHOD_NAME = 'options';

export function UseOptionsMethod(method: ProviderToken<Method<ControlOptions>>, config?: UseMethodConfig) {
  return function (target: any, propertyKey: string) {
    UseMethod(method, OPTIONS_METHOD_NAME, config)(target, propertyKey);
  };
}

export interface ExtractOptionsMethodMixin extends ExtractFormDefinitionMixin, ExtractMethodMixin,
  ExtractControlMixin {
}

@Mixin(ExtractFormDefinitionMixin, ExtractMethodMixin, ExtractControlMixin)
export class ExtractOptionsMethodMixin {

  protected extractOptionsMethod(
    control: RxapFormControl = this.extractControl(),
    formDefinition           = this.extractFormDefinition(control),
  ) {
    return this.extractMethod(formDefinition, control.controlId, OPTIONS_METHOD_NAME);
  }

}
